<div class="landing-container">
  <app-carousel [slides]="slides"> </app-carousel>
  <p>version: {{ environment.version }}</p>
</div>
